import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import $ from 'jquery';
import { I18n } from 'react-redux-i18n-lite';
import MessageAlert from './common/messageAlert/MessageAlert';
import * as messageAlert from '../actions/messageAlertAction';
import * as accountActions from '../actions/accountActions';
import { smartLoaderService } from '../services/domain/smartLoaderService';
import { getTokenFromStorage } from '../shared';
import { hasExpired, isValidUserObject } from '../services/jwt/jwtService';
import { bindActionCreators } from 'redux';
import LoginFooter from './login/Footer';
import { SHOW_LOGIN_FOOTER } from '../config_module';

class AuthenticationWrapper extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    messageAlert: PropTypes.any,
    theme: PropTypes.any
  };

  componentDidMount() {
    const { messageAlert } = this.props;
    $('#smartLoader')
      .removeClass('active')
      .removeClass('opaque');
    $('#smartLoader-loader').removeClass('active');

    if (localStorage.error === '403') {
      messageAlert.error(I18n.t('api.error.backOffice.licenseExpired'));
      localStorage.setItem('error', undefined);
    }
  }

  render() {
    const { children, theme } = this.props;
    let imgUrl = require('../styles/default/splash_screen.png');
    if (theme.images && theme.images.splashScreen) {
      imgUrl = theme.images.splashScreen;
    }
    const style = {
      backgroundImage: `url(${imgUrl})`
    };
    return (
      <div className="row authentication-wrapper align-middle align-center" style={style}>
        {children}
        <MessageAlert />
        {SHOW_LOGIN_FOOTER && <LoginFooter />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    theme: state.theme,
    isAppOnline: state.connection.status.online
  };
}

function mapDispatchToProps(dispatch) {
  return {
    messageAlert: bindActionCreators(messageAlert, dispatch),
    accountActions: bindActionCreators(accountActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationWrapper);
